var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTItvnujh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7474 4.72342C19.9343 4.52018 19.9211 4.20387 19.7179 4.01692C19.5146 3.82998 19.1983 3.84319 19.0114 4.04642L19.7474 4.72342ZM12.9284 10.8758C12.9399 11.1517 13.1729 11.366 13.4488 11.3545L17.9449 11.1668C18.2208 11.1553 18.4351 10.9223 18.4236 10.6464C18.4121 10.3705 18.1791 10.1561 17.9032 10.1677L13.9067 10.3345L13.7398 6.33801C13.7283 6.06211 13.4953 5.84779 13.2194 5.85931C12.9435 5.87083 12.7292 6.10383 12.7407 6.37973L12.9284 10.8758ZM19.0114 4.04642L13.06 10.5165L13.796 11.1935L19.7474 4.72342L19.0114 4.04642Z",
    fill: "#CACACA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24892 19.2044C4.06145 19.4072 4.07385 19.7235 4.27661 19.911C4.47936 20.0984 4.7957 20.086 4.98317 19.8833L4.24892 19.2044ZM11.0531 13.1026C11.0422 12.8266 10.8098 12.6117 10.5339 12.6225L6.03732 12.7987C5.76139 12.8095 5.54647 13.042 5.55728 13.3179C5.56809 13.5938 5.80054 13.8088 6.07647 13.798L10.0734 13.6413L10.23 17.6383C10.2408 17.9142 10.4733 18.1291 10.7492 18.1183C11.0252 18.1075 11.2401 17.875 11.2293 17.5991L11.0531 13.1026ZM4.98317 19.8833L10.9206 13.4616L10.1863 12.7827L4.24892 19.2044L4.98317 19.8833Z",
    fill: "#CACACA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5956 2.88588L22.604 21.1114C22.6044 21.9377 21.9351 22.6051 21.1044 22.6053L2.89557 22.6106C2.06698 22.6108 1.39514 21.9392 1.39514 21.1106V2.88892C1.39514 2.06049 2.06671 1.38892 2.89514 1.38892H21.0956C21.9245 1.38892 22.5952 2.05848 22.5956 2.88588Z",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTItvnujh);
export default __webpack_public_path__ + "static/media/tItvnujh.38644ed8559ce23f89f8dadd842307bb.svg";
export { ForwardRef as ReactComponent };